export default "__VITE_ASSET__RZoHhqOX__"